import Pessoa from "model/pessoa/Pessoa";
import { RootState } from "store/store"
import { EstadoRequisicao } from "store/types";


export class PessoasSelector {
  static readonly isCarregando = (it: RootState) => it.pessoas.estado === EstadoRequisicao.CARREGANDO;
  static readonly pessoa = (idPessoa: string) => (it: RootState): Pessoa|undefined => it.pessoas.cache[idPessoa];
}
